export default {
  'simulation[vehicle]': true,
  'lead[address]': true,
};
